import { render, staticRenderFns } from "./NeighborhoodAdd.vue?vue&type=template&id=bbecd3c4&scoped=true&"
import script from "./NeighborhoodAdd.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodAdd.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodAdd.vue?vue&type=style&index=0&id=bbecd3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbecd3c4",
  null
  
)

export default component.exports